


























































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class FilmIcon extends Vue {
  @Prop({ default: '30' }) readonly width?: string;
  @Prop({ default: '30' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly fill?: string;
}
